// extracted by mini-css-extract-plugin
export var stepActive = "_2j-3";
export var stepCompleted = "_2j-4";
export var stepConnectorLine = "_2j-b";
export var stepIndicatorCircle = "_2j-6";
export var stepIndicatorCircleCompleted = "_2j-7";
export var stepIndicatorCircleDefault = "_2j-8";
export var stepIndicatorTextCompleted = "_2j-9";
export var stepIndicatorTextDefault = "_2j-a";
export var stepPending = "_2j-5";
export var wizardContainer = "_2j-1";
export var wizardContent = "_2j-2";
export var wizardModal = "_2j-0";